/**
 * Transport tulis-tangan era Hono — HANYA untuk `client.ts` (permukaan yang belum publik).
 *
 * Dulu berkas ini bernama `api.ts` dan menjadi transport SATU-SATUNYA untuk seluruh
 * template. Ia diganti nama karena `./api` kini menunjuk barrel client generated orval,
 * dan dua modul berbeda yang sama-sama bisa di-resolve dari specifier `./api` adalah
 * ambiguitas yang menyelesaikan dirinya secara diam-diam ke salah satu — persis kelas bug
 * yang tidak terlihat di diff.
 *
 * Jangan pakai untuk endpoint baru. Endpoint publik dipanggil lewat hooks generated
 * (`./api`); yang tidak publik tidak boleh dipanggil template sama sekali sampai
 * kontraknya diputuskan (lihat kepala `client.ts`).
 */

// Sengaja variabel yang SAMA dengan mutator orval (api/mutator/publicFetch.ts): selama dua
// jalur masih hidup berdampingan, keduanya wajib menunjuk backend yang sama. Alasan lengkap
// kenapa default-nya `/api/v1` relatif (dan bukan host absolut) ada di kepala publicFetch.ts.
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/v1'

export async function customFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    const url = typeof input === 'string' ? input : input.toString()

    const config: RequestInit = {
        ...init,
        headers: {
            'Content-Type': 'application/json',
            ...init?.headers,
        },
    }

    try {
        const response = await fetch(url, config)

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }

        return response
    } catch (error) {
        console.error('Fetch error:', error)
        throw error
    }
}

export default customFetch
